import React, { Component } from 'react';

import Immutable, {Range} from 'immutable';
import { firebaseRoot, snapshotMap, snapshotToArray, snapshotToDeepArray } from '../../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import { Router, Route } from 'react-router';
import TouchButton from '../../components/TouchButton';
import Loader from '../../components/Loader/Loader';
import TouchLink from '../../components/TouchLink';
import LinkTR from '../../components/LinkTR';
import MathMarkup from '../../components/MathMarkup/MathMarkup';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import Input from 'react-bootstrap/lib/Input';
import Static from 'react-bootstrap/lib/FormControls/Static';
import Grid from 'react-bootstrap/lib/Grid';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import Modal from 'react-bootstrap/lib/Modal';
import DeepLinkedStateMixin from 'react-deep-link-state';
import update from 'react-addons-update';
import Lazy from 'lazy.js';
import Mousetrap from 'react-mousetrap-mixin';
import deepEqual from 'deep-equal';
import Promise from 'bluebird';
import Exercise from '../models/Exercise';


const ExerciseDetailsEditor = React.createClass({
    mixins: [DeepLinkedStateMixin, ReactFireMixin],

    getInitialState() {
        return {exercise: this.props.exercise};
    },

    saveChanges() {
        this.props.onSave(this.state.exercise);
    },

    render() {
        return <Modal show={true} onHide={this.props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Edit step...</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <MathMarkupEditor label="Text" valueLink={this.deepLinkState(['exercise', 'text'])}/>
            </Modal.Body>

            <Modal.Footer>
                <TouchButton onClick={this.props.onHide}>Close</TouchButton>
                <TouchButton bsStyle="primary" onClick={this.saveChanges}>Save changes</TouchButton>
            </Modal.Footer>
        </Modal>;
    }
});


const StepRow = React.createClass({
    mixins: [ReactFireMixin],

    getInitialState() {
        return {step: this.props.step};
    },

    stepValueLink(name) {
        return {
            value: this.props.step[name],
            requestChange: newValue => {
                this.props.step[name] = newValue;
                this.props.onChange(this.props.step);
            }
        };
    },

    render() {
        const step = this.props.step;
        return <tr>
            <td>
                <Input type="text" style={{width: 85}} valueLink={this.stepValueLink('logic')}/>
            </td>
            <td>
                <Input type="text" style={{width: 85}} valueLink={this.stepValueLink('gui')}/>
            </td>
            <td>
                <Input type="textarea" style={{width: 350}} rows="4" valueLink={this.stepValueLink('operation')}/>
                <MathMarkup>{step.operation}</MathMarkup>
            </td>
            <td>
                <Input type="text" style={{width: 85}} valueLink={this.stepValueLink('answer')}/>
            </td>
            <td>
                <Input type="textarea" style={{width: 350}} rows="4" valueLink={this.stepValueLink('hint')}/>
                <MathMarkup>{step.hint}</MathMarkup>
            </td>
            <td>
                <ButtonToolbar>
                    <TouchButton onClick={this.props.onRemove}><Glyphicon glyph="trash"/></TouchButton>
                </ButtonToolbar>
                <ButtonToolbar>
                    <TouchButton onClick={this.props.onClone}><Glyphicon glyph="duplicate"/></TouchButton>
                </ButtonToolbar>
            </td>
        </tr>;
    }
});

const StepsView = React.createClass({
    setStep(index, newStep) {
        const steps = this.props.steps;
        steps[index] = newStep;
        this.props.onChange(steps);
    },

    removeStep(index) {
        const steps = this.props.steps;
        steps.splice(index, 1);
        this.props.onChange(steps);
    },

    cloneStep(index) {
        const steps = this.props.steps;
        steps.splice(index, 0, steps[index]);
        this.props.onChange(steps);
    },

    render() {
        const steps = this.props.steps;

        if (!steps) {
            return <div>No steps defined yet.</div>;
        }

        return <table className="table table-hover">
            <thead>
            <tr>
                <th>Logic</th>
                <th>GUI</th>
                <th>Operation</th>
                <th>Answer</th>
                <th>Hint</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            {steps.map((step, i) => {
                return <StepRow key={i} step={step}
                                onChange={this.setStep.bind(this, i)}
                                onRemove={this.removeStep.bind(this, i)}
                                onClone={this.cloneStep.bind(this, i)}/>;
            })}
            </tbody>
        </table>;
    }
});

const ExerciseEditor = React.createClass({
    mixins: [ReactFireMixin],

    contextTypes: {
        history: React.PropTypes.object.isRequired
    },

    getInitialState() {
        return {updatedSteps: null, isSaving: false};
    },

    rebind(props) {
        const {params} = props;

        if (props.params.exerciseId) {
            this.bindAsDataSnapshot(
                firebaseRoot.child('admin/base/exercises')
                    .child(params.bookId)
                    .child(params.chapterId)
                    .child(params.subchapterId)
                    .child(params.exerciseId),
                'exercise');
            this.bindAsDataSnapshot(
                firebaseRoot.child('admin/steps')
                    .child(params.bookId)
                    .child(params.chapterId)
                    .child(params.subchapterId)
                    .child(params.exerciseId),
                'steps');
            // Bind two exercises, this and the next one, this is so that we can get the next one but I just
            // don't know how to only get the next one.
            this.bindAsDataSnapshot(
                firebaseRoot.child('admin/base/exercises')
                    .child(params.bookId)
                    .child(params.chapterId)
                    .child(params.subchapterId),
                'exercises');
        } else {
            this.unbind('exercise');
            this.unbind('exercises');
            this.unbind('steps');
        }
    },

    componentWillMount() {
        this.setStateAsync = Promise.promisify(this.setState);
        this.rebind(this.props);
    },

    componentWillReceiveProps(nextProps) {
        this.rebind(nextProps);
    },

    saveExercise(exercise) {
        this.state.exercise.ref().update({text: exercise.text});
        this.hideEditor();
    },

    hideEditor() {
        this.setState({showEditor: false});
    },

    showEditor() {
        this.setState({showEditor: true});
    },

    cloneTo(targetExercise) {
        if (this.state.updatedSteps) {
            if (window.confirm('Do you want to save your changes before cloning?')) {
                this.saveSteps()
                    .then(() => this.cloneTo(exercise));
            }
            return;
        }

        var params = this.props.params;
        Exercise.saveSteps(params.bookId, params.chapterId, params.subchapterId, targetExercise.key(), this.state.steps.val())
            .then(() => this.gotoExercise(targetExercise)
        );
    },

    gotoExercise(exercise) {
        if (!exercise) {
            return;
        }

        if (this.state.updatedSteps) {
            if (window.confirm('Do you want to save your changes?')) {
                this.saveSteps()
                    .then(() => this.gotoExercise(exercise));
            }
            return;
        }

        const {params} = this.props;
        this.context.history.pushState(null,
            `/admin/book/${params.bookId}/${params.chapterId}/${params.subchapterId}/${exercise.key()}`, null);
    },

    saveSteps() {
        if (!this.state.updatedSteps) {
            return Promise.resolve(this);
        }

        const {params} = this.props;
        return this.setStateAsync({isSaving: true})
            .delay(1000)
            .then(() => Exercise.saveSteps(params.bookId, params.chapterId, params.subchapterId, params.exerciseId, this.state.updatedSteps))
            .then(
                () => this.setStateAsync({updatedSteps: null, isSaving: false}),
                error => console.error(error)
            );
    },

    revert() {
        // Reset the local copy of steps, which makes it fall back on whatever is in the bound DataSnapshot.
        this.setState({updatedSteps: null});
    },

    updateSteps(steps) {
        this.setState({updatedSteps: steps});
    },

    addStep() {
        const steps = this.state.updatedSteps || snapshotToDeepArray(this.state.steps);
        steps.push({});
        this.updateSteps(steps);
    },

    render() {
        if (!this.areAllBindingsLoaded()) {
            return <div>Loading...</div>;
        }

        const {exercise, steps} = this.state;

        const exercises = snapshotToArray(this.state.exercises);
        const i = exercises.map(e => e.key()).indexOf(this.props.params.exerciseId);
        const prevExercise = exercises[i - 1];
        const nextExercise = exercises[i + 1];

        console.log(this.state.isSaving);

        return (
            <div>
                <Mousetrap mousetrap={{
                  'ctrl+n': this.gotoExercise.bind(this, nextExercise),
                  'ctrl+p': this.gotoExercise.bind(this, prevExercise),
                  'ctrl+s': this.saveSteps,
                  'ctrl+a': this.addStep
                }}/>

                <ButtonToolbar>
                    <TouchButton onClick={this.props.onDone} tabIndex={-1}>Cancel</TouchButton>
                    <TouchButton onClick={this.revert} tabIndex={-1}>Revert</TouchButton>
                    <TouchButton
                        ref="saveButton"
                        disabled={!this.state.updatedSteps || this.state.isSaving}
                        onClick={this.saveSteps}
                        tabIndex={-1}>
                        {this.state.isSaving ? <Loader/> : <Glyphicon glyph="floppy-disk"/>}&nbsp;<u>S</u>ave
                    </TouchButton>

                    <TouchButton onClick={this.addStep} tabIndex={-1}><Glyphicon glyph="plus"/>&nbsp;<u>A</u>dd step</TouchButton>

                    {nextExercise && <TouchButton onClick={this.cloneTo.bind(this, nextExercise)}>
                        <Glyphicon glyph="duplicate"/>&nbsp;Clone to next exercise ({nextExercise.key()})</TouchButton>}

                    {prevExercise && <TouchButton onClick={this.gotoExercise.bind(this, prevExercise)}>
                        <Glyphicon glyph="arrow-left"/>&nbsp;Goto <u>p</u>revious</TouchButton>}
                    {nextExercise && <TouchButton onClick={this.gotoExercise.bind(this, nextExercise)}>
                        <Glyphicon glyph="arrow-right"/>&nbsp;Goto <u>n</u>ext</TouchButton>}
                </ButtonToolbar>

                <Static label="Text">
                    <MathMarkup>{exercise.child('text').val()}</MathMarkup>
                </Static>

                <StepsView steps={this.state.updatedSteps || snapshotToDeepArray(steps)} onChange={this.updateSteps} />
            </div>
        );
    }
});

export default ExerciseEditor;



/** WEBPACK FOOTER **
 ** ./src/admin/screens/ExerciseEditor.js
 **/